import { v4 as uuid } from 'uuid';
import { toUUID } from '../../util/transform';
import type { IContactCompanyIndividual } from './ContactCompanyIndividual.interface';
import { PersonalTitle } from '../global/PersonalTitle.enum';

export default class ContactCompanyIndividual implements IContactCompanyIndividual {
  id: string;
  idContact: string;
  title: PersonalTitle;
  firstName: string;
  familyName: string;
  phoneCode: string;
  phone: string;
  email: string;
  isDirector: boolean;
  isBeneficiary: boolean;
  isPartner: boolean;
  isShareholder: boolean;
  isUnitholder: boolean;
  isEmployee: boolean;
  isSecretary: boolean;
  isOfficeHolder: boolean;

  getName() {
    return `${this.firstName} ${this.familyName}`;
  }

  static build = (data: IContactCompanyIndividual) => new ContactCompanyIndividual(data);
  static blank = () => new ContactCompanyIndividual({ id: uuid() });

  /**
   * Constructor
   * @param {IContactCompanyIndividual} data
   */
  constructor(data?: IContactCompanyIndividual) {
    this.id = toUUID(data?.id) || uuid();
    this.idContact = toUUID(data?.idContact);
    this.title = PersonalTitle.of(data?.title?.name || data?.title?.toString());
    this.firstName = data?.firstName || '';
    this.familyName = data?.familyName || '';
    this.phoneCode = data?.phoneCode || '';
    this.phone = data?.phone || '';
    this.email = data?.email || '';
    this.isDirector = data?.isDirector === true;
    this.isBeneficiary = data?.isBeneficiary === true;
    this.isPartner = data?.isPartner === true;
    this.isShareholder = data?.isShareholder === true;
    this.isUnitholder = data?.isUnitholder === true;
    this.isEmployee = data?.isEmployee === true;
    this.isSecretary = data?.isSecretary === true;
    this.isOfficeHolder = data?.isOfficeHolder === true;
  }
}
